
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.18 8.82H4.82V2.18c0-.443.17-.834.508-1.172C5.667.669 6.058.5 6.5.5h5c.443 0 .833.17 1.172.508.338.338.508.729.508 1.172v6.64zM.68 6.32h2.5v2.5H.68v-2.5zm14.14 0h2.5v2.5h-2.5v-2.5zM2.32 15.5v-5h13.36v5h-2.5V13H4.82v2.5h-2.5z","fill":"currentColor"}})])
          )
        }
      }
    